import { Component, HostListener, OnInit, ViewChild } from '@angular/core';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { Job } from 'src/@core/interfaces/job/job.model';
import { JobService } from 'src/@core/services/job/job.service';
import { ActivatedRoute, NavigationExtras, Router } from '@angular/router';
import { fadeInRight400ms } from 'src/@core/animations/fade-in-right.animation';
import { scaleIn400ms } from 'src/@core/animations/scale-in.animation';
import { Employer } from 'src/@core/interfaces/employer/employer.model';
import { EmployerService } from 'src/@core/services/employer/employer.service';
import { JobType } from 'src/@core/interfaces/job/job-type.model';
import { JobTypeService } from 'src/@core/services/job/job-type.service';
import { entityTypes, permissions, roles } from 'src/app/shared/helpers/roles-permissions';
import { environment } from 'src/environments/environment';
import { NotificationService } from 'src/@core/services/notification.service';
import { MatDialog } from '@angular/material';
import { CreateQuoteComponent } from '../quotes/create-quote/create-quote.component';
import { AppService } from 'src/@core/services/app.service';
import { AssignJobAdminComponent } from 'src/app/modules/employment/assign-job-admin/assign-job-admin.component';
import { HttpClient, HttpParams, HttpResponse } from '@angular/common/http';
import { API_WORK_ORDER_EXPORT, GET_PO, GET_QUOTATION } from 'src/@core/services/util/api.endpoints';
import { AssignVendorComponent } from 'src/app/modules/enterprise-admin/users/assign-vendor/assign-vendor.component';
import { EnterpriseAdminService } from 'src/app/modules/enterprise-admin/enterprise-admin.service';

@Component({
  selector: 'hour4u-admin-view-job',
  templateUrl: './view-job.component.html',
  styleUrls: ['./view-job.component.scss'],
  animations: [fadeInRight400ms, scaleIn400ms]
})
export class ViewJobComponent implements OnInit {
  data: Job = new Job();
  employer: Employer;
  jobType: JobType;
  roles = roles;
  entityTypes = entityTypes;
  permissions = permissions;
  imageUrl = environment.image_url;
  profile = this.appService.getCurrentAccount();
  isLoading: boolean = false;
  enableAssignButton: boolean = false;
  quoteList: any[] = [];
  quoteListEnterprise: any[] = []
  poList: any[] = [];
  timesheetList: any[] = [];
  screenWidth = window.innerWidth;
  // billingList: any[] = [];
  vendorView: boolean = false;
  disableAssignButton: boolean = true
  diameter = 40;

  @ViewChild('quoteListComponent', { static: false }) quoteListComponent: any; // Reference to child component

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.screenWidth = event.target.innerWidth;
  }
  resultsLength: number = 0;
  pageIndex: number = 0;
  pageSize: number = 20;
  workorderList: any[] = [];
  selectedTabIndex: any;
  selectedTab: string = "";
  membersList: any[] = [];
  isExporting: boolean = false;
  params: any = new HttpParams();
  color: string = '#D95938';
  mode: string = 'indeterminate'
  actionButtons = [];
  projectDetails: any;

  constructor(
    private jobService: JobService,
    private employerService: EmployerService,
    private jobTypeService: JobTypeService,
    private route: ActivatedRoute,
    private router: Router,
    private notify: NotificationService,
    private dialog: MatDialog,
    private appService: AppService,
    private http: HttpClient,
    private enterpriseAdminService: EnterpriseAdminService
  ) { }

  ngOnInit() {
    this.route.params.subscribe(data => {
      console.log(data)
      this.data.id = data.id;
      this.selectedTab = data.selectedTab;
      this.getProjectById(this.profile.entity.id, this.data.id)
      //this.getCurrentRole();
      //this.ctaSet();
    });
  }

  ctaSet() {
    this.actionButtons = [
      {
        name: 'Export',
        click: () => this.exportData(),
        show: true // Always show Export button
      },
      {
        name: 'Assign Vendor',
        click: () => this.assignVendor(),
        show: this.showAssignVendorCTA() && this.profile.entity.type === entityTypes.AGENCY
      },
      {
        name: 'Create Workorder',
        click: () => this.createWorkOrder(),
        show: this.data.selectedClientType === 'Self' && this.profile.entity.type === entityTypes.AGENCY
      },
      {
        name: 'Reject',
        click: () => this.approveRejectProject(this.data, 'REJECTED'),
        show: this.shouldShowRejectButton()
      },
      {
        name: 'Accept',
        click: () => this.approveRejectProject(this.data, 'ACCEPTED'),
        show: this.shouldShowAcceptButton()
      }
    ].filter(button => button.show);

    console.log(this.actionButtons); // Log the buttons for debugging
  }


  shouldShowRejectButton() {
    const canShow = this.data.assignmentStatus &&
      this.data.assignmentStatus !== 'REJECTED' &&
      !this.workorderList.length &&
      !this.vendorView &&
      this.data.createdByEntity.id !== this.profile.entity.id;

    console.log('Should Show Reject Button:', canShow); // Debugging output
    return canShow;
  }

  shouldShowAcceptButton() {
    const canShow = (this.data.assignmentStatus === 'REQUESTED' || this.data.assignmentStatus === 'REJECTED') && !this.vendorView;

    console.log('Should Show Accept Button:', canShow); // Debugging output
    return canShow;
  }

  // Function to get the tab index based on the tab label
  private getTabIndex(tabLabel: string): number {
    let tabs = [];
    // if (this.billingList && this.billingList.length && this.data.billingType && this.data.billingType != 'NONE') {
    //   tabs.push('Bills');
    // }
    tabs.push('Timesheet');
    if (this.workorderList && this.workorderList.length) {
      tabs.push('Workorders');
    }
    if (this.poList && this.poList.length) {
      tabs.push('Purchase orders');
    }
    if (this.quoteList && this.quoteList.length) {
      tabs.push('Quotes');
    }
    if (this.data) {
      tabs.push('Members');
      tabs.push('Vendors')
      tabs.push('Details');
    }
    return tabs.findIndex(tab => tab === tabLabel);
  }

  getCurrentRole() {
    this.appService.currentUser.subscribe(currentUser => {
      if (currentUser && currentUser.roles && currentUser.roles.length) {
        currentUser.roles.forEach(ele => {
          this.loadData();
          this.getPOData(this.vendorView);
          this.getQuotesData(this.vendorView);
          // this.getBillingsData();
          this.checkQuoteStatusWithVendorView();
          //this.fetchWorkOrdersBYJobId();
          //this.fetchAttendanceSheetData();
          setTimeout(() => {
            this.route.url.subscribe(urlSegments => {
              if (urlSegments.findIndex(segment => segment.path === this.selectedTab) !== -1) {
                this.selectedTabIndex = this.getTabIndex(this.selectedTab);
              }
              for (let segment of urlSegments) {
                if (segment.path === 'Purchase%20orders') {
                  this.selectedTabIndex = this.getTabIndex('Purchase orders');
                  break;
                }
                else if (segment.path === 'Time%20sheet') {
                  this.selectedTabIndex = this.getTabIndex('Timesheet');
                  break;
                } else {
                }
              }
            });
          }, 1500);
        })
      }
    })
  }
  /**
   * Get job from server
   */
  loadData() {
    this.isLoading = true;
    let params = {};
    if (this.profile && this.profile.entity && this.profile.entity.id) {
      if (this.profile.entity.entityType == 'AGENCY' || this.profile.entity.entityType == 'VENDOR') {
        params = { 'entityId': this.profile.entity.id };
      }
    }
    if (this.data && this.data.id) {
      this.jobService.getJobDetailsById(this.data.id, params).subscribe((job: any) => {
        this.isLoading = false;
        this.data = job;
        //this.enableAssignButton = true;
        console.log(this.data)
        if (this.data && this.data.jobTypeId) {
          this.loadJobType();
        }
      })
    } else {
      this.isLoading = false;
    }
  }

  /**
   * Get emplyer from server to show
   */
  loadJobType() {
    this.jobTypeService.getById(this.data.jobTypeId).subscribe(type => {
      this.jobType = type;
    })
  }

  // get Quotes Data
  getQuotesData(vendorView) {
    console.log("getQuotesData called")
    this.isLoading = true;
    const sort = 'createdOn,desc';
    this.quoteList = [];
    const httpParams = new HttpParams()
      .set('sort', sort)
      .set('jobId', this.data.id.toString())
      .set('vendorView', vendorView.toString())
    // .set('size', this.pageSize.toString())

    this.http.get<any>(GET_QUOTATION, { params: httpParams }).subscribe(
      (response) => {
        this.isLoading = false;
        if (response && Array.isArray(response)) {
          if (response && response.length) {
            response.forEach(element => {
              if (element.quoteConditions && element.quoteConditions.expiryDate) {
                element.quoteConditions.quoteValidity = element.quoteConditions.expiryDate;
              }
              element.totalCost = 0;
              // element.status = 0;
              if (element.jobRateCards && element.jobRateCards.length) {
                element.jobRateCards.forEach(ele => {
                  element.totalCost = element.totalCost + ele.totalAmount;
                  // element.totalUnits = element.totalUnits + ele.quantity;
                });
                element.totalCost = element.totalCost * 1.18;
              }
              // element.assignedEntitiesName = [];
              // if (element.assignedEntities && element.assignedEntities.length) {
              //   element.assignedEntities.forEach(ele => {
              //     element.assignedEntitiesName.push(ele.name);
              //   });
              // }

            });
          }
          this.quoteList = response;
          console.log("this.quoteList", this.quoteList)
          this.resultsLength = this.quoteList.length;
          // this.selection.clear();
          //this.quoteList.forEach(row => this.selection.select(row));
        }
        // if (this.data && this.data.billingType == 'NONE') {
        //   this.columns = this.columns.map(x => {
        //     x.visible = true;
        //     if (x.columnDef === 'finalAmount' || x.columnDef === 'paymentTerms')
        //       x.visible = false;
        //     return x;
        //   });
        //   this.displayedColumns = this.columns.filter(x => x.visible).map(x => x.columnDef);
        // }
      },
      (error) => {
        this.isLoading = false;
        console.error('Failed to fetch bookings:', error);
      }
    );
  }

  checkQuoteStatusWithVendorView() {
    this.isLoading = true;
    const sort = 'createdOn,desc';
    this.quoteListEnterprise = [];
    const httpParams = new HttpParams()
      .set('sort', sort)
      .set('jobId', this.data.id.toString())
      .set('vendorView', 'false');

    this.http.get<any>(GET_QUOTATION, { params: httpParams }).subscribe(
      (response) => {
        this.isLoading = false;
        if (response && Array.isArray(response)) {
          this.quoteListEnterprise = response;
          console.log("################", this.quoteListEnterprise)
          // Check if client is self or not then the status of the first item in the quoteListEnterprise

          if (this.data && this.data.enterpriseDetails !== null) {
            if (this.quoteListEnterprise.length > 0 &&
              (this.quoteListEnterprise[0].status === 'PENDING' || this.quoteListEnterprise[0].status === 'REJECTED')) {
              this.disableAssignButton = true;
            } else {
              this.disableAssignButton = false;
            }
          }

        }
      },
      (error) => {
        this.isLoading = false;
        console.error('Failed to fetch quotes:', error);
      }
    );
  }


  // get PO Data
  getPOData(vendorView) {
    this.isLoading = true;
    const sort = 'createdOn,desc';
    this.poList = [];
    const httpParams = new HttpParams()
      .set('sort', sort)
      .set('jobId', this.data.id.toString())
      .set('vendorView', vendorView.toString())
    // .set('page', this.pageIndex.toString())
    // .set('size', this.pageSize.toString())

    this.http.get<any>(GET_PO, { params: httpParams }).subscribe(
      (response) => {
        this.isLoading = false;
        if (response && Array.isArray(response)) {
          this.poList = response;
        }
      },
      (error) => {
        this.isLoading = false;
        console.error('Failed to fetch bookings:', error);
      }
    );
  }

  // // get WorkOrder Data
  // fetchWorkOrdersBYJobId() {
  //   this.isLoading = true;
  //   let selectedAgency = [];
  //   if (this.profile.roles.indexOf(roles.AGENCY_ADMIN) > -1 || this.profile.roles.indexOf(roles.AGENCY_STAFF) > -1) {
  //     selectedAgency.push(this.profile.entity.id);
  //   }
  //   let obj = {
  //     "jobId": this.data.id,
  //     "agency": selectedAgency
  //   }
  //   this.jobService.fetchWorkorderByJobId(obj)
  //     .subscribe(
  //       (response) => {
  //         this.workorderList = response;
  //         this.isLoading = false;
  //       },
  //       (error) => {
  //         this.isLoading = false;
  //         console.error('Failed to fetch dashboard data:', error);
  //       }
  //     );
  // }

  // get Billing Data
  // getBillingsData() {
  //   this.isLoading = true;
  //   let entityId = "";
  //   if (this.profile.roles.indexOf(roles.AGENCY_ADMIN) > -1 || this.profile.roles.indexOf(roles.AGENCY_STAFF) > -1) {
  //     entityId = '&createdByEntityId=' + this.profile.entity.id;
  //   }

  //   if (this.profile.roles.indexOf(roles.ENTERPRISE_ADMIN) > -1 || this.profile.roles.indexOf(roles.ENTERPRISE_STAFF) > -1) {
  //     entityId = '&paidByEntityId=' + this.profile.entity.id;
  //   }
  //   this.jobService.getBillingList(this.data.id, entityId)
  //     .subscribe(
  //       (response) => {
  //         this.billingList = response;
  //         this.isLoading = false;
  //       },
  //       (error) => {
  //         this.isLoading = false;
  //         console.error('Failed to fetch dashboard data:', error);
  //       }
  //     );
  // }

  // fetchAttendanceSheetData() {
  //   const jobId = this.data.id;
  //   let searchParams = [];
  //   if (jobId) {
  //     const sortField = 'createdOn';
  //     const sortOrder = 'desc';
  //     let groupBy = 'agency';
  //     const pageIndex = 0;
  //     const pageSize = 9999;
  //     this.jobService.getTimesheetData(
  //       jobId,
  //       groupBy,
  //       pageIndex,
  //       pageSize,
  //       sortField,
  //       sortOrder,
  //       searchParams
  //     ).subscribe((res: any) => {
  //       this.timesheetList = res;
  //     }, (err: any) => {
  //       console.log(err)
  //     })
  //   }
  // }


  // create Work Order
  createWorkOrder() {
    console.log(this.data, this.employer, this.jobType);
    const navigationExtras: NavigationExtras = {
      queryParams: { 'jobId': this.data.id, 'jobTypeId': this.data.jobTypeId, 'employerId': this.data.employerId }
    }
    this.router.navigate(['/enterprise-admin/create-work-order'], navigationExtras);
  }

  // approve/reject Project
  approveRejectProject(data, status) {
    console.log(data, status)
    this.jobService.updateProjectStatus(data.assignmentId, status).subscribe(res => {
      this.loadData();
      this.notify.showMessage('Project Status Updated Successfully!', 2000);
    }, ((err: any) => {
      this.notify.showMessage(err.error.message, 2000);
    }))
  }

  // prepare And Send Quote
  prepareAndSendQuote() {
    this.data.action = 'Create';
    const dialogRef = this.dialog.open(CreateQuoteComponent, {
      width: '900px',
      panelClass: 'add-edit-staff-dialog',
      disableClose: true,
      data: this.data,
      autoFocus: true
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.getCurrentRole();
      }
    });
  }

  // tab change
  onTabChanged(event) {
    console.log(event, event.tab.textLabel)
    if (event.tab.textLabel === "Purchase orders") {
      this.jobService.setRefreshPOPage();
    }
    if (event.tab.textLabel === "Quotes") {
      this.jobService.setRefreshQuotePage();
    }
    if (event.tab.textLabel === "Workorders") {
      this.jobService.setRefreshWorkorderPage();
    }
    // if (event.tab.textLabel === "Bills") {
    //   this.jobService.setRefreshBillingPage();
    // }
    if (event.tab.textLabel === "Vendors") {
      //this.jobService.setRefreshBillingPage();
    }
    if (event.tab.textLabel === "Details") {
      this.loadData();
    }
  }

  // assign Agency
  assignAgency() {
    const dialogRef = this.dialog.open(AssignJobAdminComponent, {
      width: '600px',
      panelClass: 'assign-dialog',
      disableClose: true,
      data: this.data
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.getCurrentRole();
      }
    });
  }

  //assign Vendor
  assignVendor() {
    const dialogRef = this.dialog.open(AssignVendorComponent, {
      width: '1024px',
      panelClass: 'assign-dialog',
      disableClose: true,
      data: this.data
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.getCurrentRole();
      }
    });
  }

  sendQuoteToAgency() {
    const obj = {
      entityId: this.profile.entity.id,
      jobId: this.data.id,
      assignmentId: this.data.assignmentId,
      status: "PENDING",
      jobRateCards: this.data.rateCards.map(card => ({
        type: card.type,
        quantity: card.quantity,
        rate: card.rate,
        totalAmount: card.totalAmount
      })),
      variableJobRateCards: this.data.variableJobRateCards || [],
      quoteConditions: {
        quoteValidity: [
          new Date().getFullYear(), // Replace with actual date values if needed
          new Date().getMonth() + 1, // Month is 0-indexed
          new Date().getDate()
        ],
        paymentTerms: "45 days",
        addtional: null
      },
      attachments: this.data.attachments || []
    };
    console.log("obj", obj)


    this.jobService.createQuotation(obj).subscribe(res => {
      console.log('Quote sent successfully:', res);
      this.notify.showMessage('Quote sent successfully!', 2000);


    }, err => {
      console.error('Failed to send quote:', err);
      this.notify.showMessage('Failed to send quote!', 2000);
    });
  }

  setView(view: 'enterprise' | 'vendor') {
    console.log('Selected view:', view);

    if (view === 'enterprise') {
      this.vendorView = false;
      this.getQuotesData(this.vendorView);
      this.getPOData(this.vendorView);
      //this.fetchWorkOrdersBYJobId();
    } else {
      this.vendorView = true;
      this.getQuotesData(this.vendorView);
      this.getPOData(this.vendorView);
      //this.fetchWorkOrdersBYJobId();
    }
  }

  // Show assign vendor CTA quoteConditions
  showAssignVendorCTA() {
    let isVisible = false;
    if (this.data && this.data.assignmentStatus && this.data.assignmentStatus == 'ACCEPTED') {
      if (this.data.quotationRequired) {
        if (this.quoteList && this.quoteList.length) {
          if (this.quoteList[0].status == 'ACCEPTED'
            || this.quoteList[0].status == 'PO_NOT_REQUIRED'
            || this.quoteList[0].status == 'PO_CREATED') {
            isVisible = true;
          }
        }
      } else {
        isVisible = true;
      }
    }
    return isVisible;
  }

  filterChange(event) {
    console.log(event);
    this.params = event;
  }

  exportData() {
    this.isExporting = true;
    console.log(this.params);
    let params = this.params;
    params = params.set('jobId', this.data.id);
    this.http.get(API_WORK_ORDER_EXPORT, { params, responseType: 'blob', observe: 'response' })
      .subscribe((response: HttpResponse<Blob>) => {
        this.isLoading = false;
        this.isExporting = false;
        // Handle the API response, which is a file to download
        const blob = new Blob([response.body!], { type: 'application/octet-stream' });
        const url = window.URL.createObjectURL(blob);

        // Create a link element and trigger the download
        const a = document.createElement('a');
        a.href = url;
        a.download = 'workorder-data.xlsx'; // specify the desired filename here
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
      }, (err => {
        this.isLoading = false;
        this.isExporting = false;
      }));
  }

  getProjectById(entityId: string, projectId: string) {
    console.log('Agent details retrieved successfully:');

    this.jobService.getProjectById(entityId, projectId).subscribe(
      (response) => {
        console.log('Agent details retrieved successfully:', response);
        this.projectDetails = response;
      },
      (error) => {
        console.error('Failed to fetch agent details:', error);
      }
    );
  }
}